export function formatAccountText(account) {
  return `${account.bank || "-"} - ${account.accountNumber || "-"} (${account.currency || "-"})`;
}

export function formatMoney(value, currency) {
  const numericValue = Number(value || 0);
  return `${new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue)} ${currency}`;
}

export function formatRate(value) {
  const numericValue = Number(value || 0);
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(numericValue);
}

export function formatAccountNumber(accountNumber) {
  if (!accountNumber) return "-";
  return accountNumber.replace(/\s+/g, "").replace(/(.{4})/g, "$1 ").trim();
}

export function formatDateTime(value) {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleString();
}

export function formatDate(date) {
  if (!date) return "-";

  return new Date(date).toLocaleString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}